/* unplugin-vue-components disabled */import { render } from "./redScreen.vue?vue&type=template&id=613c0caa&scoped=true&ts=true"
import script from "./redScreen.vue?vue&type=script&lang=ts"
export * from "./redScreen.vue?vue&type=script&lang=ts"

import "./redScreen.vue?vue&type=style&index=0&id=613c0caa&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613c0caa"]])

export default __exports__